/* The one owner of document.body's pinned state.
 *
 * The nav's full-page menu and the cart drawer both need the page under them
 * to hold still, and either can be opened while the other is already open. If
 * both wrote document.body.style they would clobber each other: whichever
 * closed first would clear the pin the other still wanted, and the offset one
 * of them stored would be handed back to the reader by the other. So the style
 * is written here and nowhere else, and the body is pinned if and only if at
 * least one holder still wants it.
 *
 * overflow:hidden alone is ignored by mobile Safari; pinning the body is what
 * actually stops it, and the stored offset is what keeps the release from
 * dropping the reader back at the top of the page. */

const holders = new Set();
let offset = 0;

export function lockScroll(holder) {
  if (holders.has(holder)) return;
  const first = holders.size === 0;
  holders.add(holder);
  if (!first) return;

  // Only the first holder may read the offset: once the body is fixed,
  // window.scrollY reads 0, and a second reading would lose the reader's place.
  offset = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${offset}px`;
  document.body.style.width = '100%';
}

export function unlockScroll(holder) {
  if (!holders.delete(holder)) return;
  if (holders.size) return;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, offset);
}

/* The router sends every view to the top, so after a navigation the stored
   offset belongs to a page that is already gone. */
export function forgetScrollOffset() {
  offset = 0;
}
